//const BASE_URL = "http://192.168.1.239/vishnavi/api"
const BASE_URL = "https://vaishnavi.oakyaitservices.in/api"

const API_URLS = {

  loginemployee: {
    url: `${BASE_URL}/employee_login.php`,
    method: 'POST',
  },

createemployee: {
  url: `${BASE_URL}/create.php`,
  method: 'POST',
},
createstudent: {
  url: `${BASE_URL}/student_create.php`,
  method: 'POST',
},
getemployees: {
  url: `${BASE_URL}/employee_retrieve.php`,
  method: 'GET',
},
getstudents: {
  url: `${BASE_URL}/student_retrieve.php`,
  method: 'GET',
},
getstudentsByEmployeeId: {
  url: `${BASE_URL}/student_retrieve.php`,
  method: 'PUT',
},

getstudentsByEmployeeId: {
  url: `${BASE_URL}/student_retrieve.php`,
  method: 'PUT',
},





getdashboardcount: {
  url: `${BASE_URL}/dashboard_count.php`,
  method: 'GET',
},






};
export default API_URLS;
